interface SMSParams {
  number: string;
  message: string;
  apiKey?: string;
  senderId?: string;
}

export const sendSMS = async ({ number, message, apiKey, senderId }: SMSParams) => {
  // Determine if we're in development or production
  const apiUrl = process.env.NODE_ENV === 'development' 
    ? 'http://localhost:5000/api/send-sms' 
    : '/api/send-sms';
  
  try {
    // Use relative URL instead of hardcoded localhost:5000
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        number,
        message,
        apiKey,
        senderId
      }),
    });
    
    if (!response.ok) {
      // Try to get error details from response
      try {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to send SMS');
      } catch (parseError) {
        // Handle case where response isn't valid JSON
        throw new Error(`SMS request failed with status: ${response.status} ${response.statusText}`);
      }
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error sending SMS:', error);
    throw error;
  }
}; 